import { logger } from '@gem/modules/logger';

import { IUserDeviceKeyPackage } from 'APP/model/e2ee/e2eeModel.types';
import { e2eeModel } from 'APP/model/model';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';

import { getCommitMessages } from './getCommitMessages';

interface IAcceptSecretGroupAccessRequestStatusParams {
  groupId: string;
  deviceId: string;
  userId: string;
  keyPackage: IUserDeviceKeyPackage;
  retry?: boolean;
}

export const acceptSecretGroupAccessRequestStatus = async (
  params: IAcceptSecretGroupAccessRequestStatusParams
): Promise<{ error: string | null }> => {
  try {
    const mlsGroup = MlsStorageService.loadGroup(params.groupId);

    if (!mlsGroup) {
      throw new Error('MlsGroup does not exist');
    }

    const commitBuilderWithRemovedMembers = MlsStorageService.findMemberIdsInGroupAndRemove(
      [params.deviceId],
      mlsGroup
    );

    const addMembersResult = MlsStorageService.addMembersToGroup(
      [params.keyPackage],
      mlsGroup,
      commitBuilderWithRemovedMembers || undefined
    );

    const response = await e2eeModel.acceptSecretChatAccessRequests({
      participantsWelcomeMessages: addMembersResult.welcomeMessages,
      commit: addMembersResult.commit,
      epoch: addMembersResult.epoch,
      groupId: params.groupId,
    });

    if (response.needToSyncCommits && !params.retry) {
      await getCommitMessages(params.groupId, Number(mlsGroup.currentEpoch()));
      return await acceptSecretGroupAccessRequestStatus({ ...params, retry: true });
    } else {
      MlsStorageService.processMyWelcomeCommit(addMembersResult.welcomeCommit, mlsGroup);
    }

    return { error: null };
  } catch (error) {
    logger.get('Tasks').error('e2ee.acceptSecretGroupAccessRequestStatus', error);
    return { error: error.message };
  }
};
